/**
 * Aba Varejo v1 (issue #242) — Visão Geral | Curva ABC | Valuation.
 *
 * Valuation (#4 PR2): réplica do Estudo MTM, marcada a mercado, consumindo
 * GET /api/varejo/valuation (substituiu o placeholder honesto do PR #243).
 */
import { useState } from "react";
import { SubTabs, type SubTabSpec } from "../components/ui/SubTabs";
import { CarteiraVivaTab } from "../components/varejo/CarteiraVivaTab";
import { CurvaAbcTab } from "../components/varejo/CurvaAbcTab";
import { ValuationTab } from "../components/varejo/ValuationTab";
import { VisaoGeralTab } from "../components/varejo/VisaoGeralTab";

export type VarejoTab = "visao" | "abc" | "valuation" | "viva";

const TABS: SubTabSpec<VarejoTab>[] = [
  { id: "visao", label: "Visão Geral" },
  { id: "abc", label: "Curva ABC" },
  { id: "valuation", label: "Valuation" },
  // #2 (10/08): carteira VIVA lado a lado com a réplica do Estudo.
  { id: "viva", label: "Carteira Viva" },
];

export function VarejoPage({
  onTabChange,
}: {
  onTabChange?: (t: VarejoTab) => void;
}) {
  const [tab, setTab] = useState<VarejoTab>("visao");

  function change(t: VarejoTab) {
    setTab(t);
    onTabChange?.(t);
  }

  return (
    <div>
      <SubTabs tabs={TABS} active={tab} onChange={change} />
      <div className="mt-6">
        {tab === "visao" && <VisaoGeralTab />}
        {tab === "abc" && <CurvaAbcTab />}
        {tab === "valuation" && <ValuationTab />}
        {tab === "viva" && <CarteiraVivaTab />}
      </div>
    </div>
  );
}
